import { TrackedEvent } from '@enmon/commons/lib/enmon';
import { useServices } from '@/components/Services';
import { bugReportActions } from '@/containers/App/actions';
import type { BugReportResult, BugReportArg } from '@/services/api/support/types/types';
import { type UseMutationResult, useMutation } from 'react-query';
import { useDispatch } from 'react-redux';
import { trackEvent } from '@/hooks/google_analytics/trackEvent';

export const useBugReport = (
  onSuccess?: () => void,
): UseMutationResult<BugReportResult, unknown, BugReportArg, unknown> => {
  const dispatch = useDispatch();
  const { supportApiClient } = useServices();

  return useMutation({
    mutationFn: async (args: BugReportArg) => await supportApiClient.reportBug(args),
    onSuccess: () => {
      dispatch(bugReportActions.create.success());
      trackEvent(TrackedEvent.BugReported);
      onSuccess?.();
    },
    onError: error => {
      console.error('Bug report failed:', error);
    },
  });
};
